import * as firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/functions'

const config = {
    apiKey: "AIzaSyArkSoT39Hj5KMDT9bPboUog5yYO63zX6E",
    authDomain: "cat-production.firebaseapp.com",
    databaseURL: "https://cat-production.firebaseio.com",
    projectId: "cat-production",
    storageBucket: "cat-production.appspot.com",
    messagingSenderId: "883915272209",
    appId: "1:883915272209:web:f8116277d9de3f71e901b0"
}

const app = firebase.initializeApp(config)
const auth = app.auth();

export { app, auth }